import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Button, Box, Typography, CircularProgress } from '@mui/material';

export const AuthStatus = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return <CircularProgress size={24} />;
  }

  if (auth.error) {
    return (
      <Box>
        <Typography color="error">Authentication error: {auth.error.message}</Typography>
        <Button 
          variant="contained" 
          onClick={() => auth.signinRedirect()}
        >
          Log in
        </Button>
      </Box>
    );
  }

  if (auth.isAuthenticated) {
    console.log(auth.user);
    return (
      <>
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <Typography variant="h6">
          Welcome <strong>{auth.user?.profile.name || auth.user?.profile.email || 'User'}</strong>! Redirecting to docs portal...
        </Typography>
        {/* <Button 
          variant="outlined" 
          size="small"
          onClick={() => auth.removeUser()}
        >
          Log out
        </Button> */}
        <CircularProgress size={24} />
      </Box>
      
      </>
    );
  }

  return (
    <Button 
      variant="contained" 
      onClick={() => auth.signinRedirect()}
    >
      Log in
    </Button>
  );
};
